<template>
  <div class="flow-create-release-wrap">

    <el-result :icon="value.master.status ? 'success' : 'info'" :title="value.master.status ? '已发布' : '未发布'" :subTitle="getDescription()"></el-result>

    <el-button size="medium" class="release-btn" type="primary" @click="save(1)" :loading="loading">发布流程</el-button>
    <el-button size="medium" class="save-btn" plain @click="save(0)" :loading="loading">只保存，不发布</el-button>
    <el-button type="danger" size="medium" class="remove-btn" plain @click="clearCache()" v-if="value.master.cache" :loading="loading">删除未发布数据</el-button>

  </div>
</template>

<script>

import Http from "../common/Http";

export default {
  name:"flow-create-release",
  props: ["value"],
  data () {
    return {
      loading: false
    }
  },
  activated() {

    console.log('flow release activated')

    if(this.value.master.status == 1) this.$parent.changeStep(5)
    // if(this.value.master.status == 1) this.$parent.changeStep(6)

  },
  methods: {

    getDescription() {
      return `创建时间：${this.value.master.create_time_formatted}，更新时间：${this.value.master.update_time_formatted}，发布时间：${this.value.master.release_time_formatted}`
    },

    // 发布或保存流程数据
    save(is_release) {

      let saveFunc = () => {

        this.loading = true

        let cache

        if(this.value.master.cache != '' && this.value.master.cache != null) {

          cache = this.value.master.cache

        } else {

          let master = this.value.master
          cache = {
            master: {
              id: master.id,
              name: master.name,
              type_id: master.type_id,
              weight: master.weight,
              model_id: master.model_id,
              sheet_id: master.sheet_id,
              form_id: master.form_id,
              status: master.status,
              is_h5: master.is_h5,
              is_hide: master.is_hide,
              title_rule: master.title_rule,
              serial_number_rule: master.serial_number_rule,
            },
            model: this.value.model ? this.value.model : {},
            sheet: {
              id: this.value.sheet ? this.value.sheet.id : 0
            },
            form: this.value.form ? this.value.form : {}
          }

        }

        Http.post("flow/FlowMaster/saveFlow", {
          id: this.value.master.id,
          cache: JSON.stringify(cache),
          is_release: is_release
        }, res => {
          this.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
          if(res.code == 1) {
            this.$parent.getFlowInfo(this.value.master.id)
          }
          this.loading = false
        })

      }

      if(is_release) {
        this.$confirm('确定要发布此流程吗?', '提示', {type: 'warning'}).then(() => {
          saveFunc()
        })
      } else {
        saveFunc()
      }

    },

    // 删除未发布数据
    clearCache() {

      this.$confirm('此操作将删除未发布的数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        this.loading = true
        Http.post("flow/FlowMaster/clearFlowCache", {id: this.value.master.id}, res => {
          this.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
          if(res.code == 1) {
            this.$parent.getFlowInfo(this.value.master.id)
          }
          this.loading = false
        })
      })

    }

  }
}
</script>
<style lang="scss" scoped>

@import '../common.scss';

.flow-create-release-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  flex-direction: column;
  padding-bottom: 50px;

  .release-btn,.save-btn,.remove-btn {
    min-width: 300px;
  }

  .save-btn,.remove-btn {
    margin-top: 10px;
    margin-left: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowCreateRelease.vue